import { Icon } from './Icon';

type PillKind = 'secure' | 'verified' | 'queue';

interface SecurePillProps {
  kind?: PillKind;
  label?: string;
}

/** The small trust pill in the app bar. 'queue' variant uses the --wait token. */
export function SecurePill({ kind = 'secure', label }: SecurePillProps): JSX.Element {
  if (kind === 'queue') {
    return (
      <span className="secure-pill is-queue">
        <span className="live-dot" />
        {label ?? 'Live queue'}
      </span>
    );
  }
  if (kind === 'verified') {
    return (
      <span className="secure-pill">
        <Icon name="shield" size={13} />
        {label ?? 'Verified'}
      </span>
    );
  }
  return (
    <span className="secure-pill">
      <Icon name="lock" size={13} />
      {label ?? 'Secure'}
    </span>
  );
}
